module.exports = __webpack_public_path__ + "assets/3d600702b0f44a369851de10a445efde.svg";